import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { DIALOG_TYPE } from '../../../constants';
import { Dialog } from '../../../ui';
import {
  AssessmentContext,
  DefaultAssessmentState,
} from '../../../utils/contexts/contexts';
import { BasicInformation } from './form_content/basic_information/basic_information';
import { CreateQuestions } from './form_content/create_questions/create_questions';
import { SettingsAndPermissions } from './form_content/settings_and_permissions/settings_and_permissions';
import { ChooseAssessmentTypeModal } from './modal_content/choose_assessment_type_modal';

export const CreateAssessmentPage: React.FC = () => {
  const history = useHistory();
  const [assessmentState, setAssessmentState] = useState(
    DefaultAssessmentState.assessmentState,
  );
  const [confirmDialogState, setConfirmDialogState] = useState(false);

  const [modalState, setModalState] = useState<boolean>(
    assessmentState.assessmentType === null,
  );

  const renderFormPage = () => {
    if (
      assessmentState.assessmentType !== null &&
      assessmentState.assessmentPageNo === 1
    ) {
      return <BasicInformation />;
    } else if (assessmentState.assessmentPageNo === 2) {
      return <CreateQuestions />;
    } else if (assessmentState.assessmentPageNo === 3) {
      return <SettingsAndPermissions />;
    }
  };

  const handleModalToggle = () => {
    setModalState(false);
    history.push('/assessment-list');
  };

  return (
    <AssessmentContext.Provider
      value={{
        assessmentState: assessmentState,
        setAssessmentState: setAssessmentState,
      }}
    >
      <Box sx={{ width: '100%', p: 3 }}>
        {renderFormPage()}

        <ChooseAssessmentTypeModal
          open={modalState}
          onClose={() => {
            setConfirmDialogState(true);
          }}
          onSuccessClose={() => setModalState(false)}
        />
        <Dialog
          title='Are you sure you want to cancel?'
          handleApply={handleModalToggle}
          confirmButtonLable='Yes, Cancel'
          isOpen={confirmDialogState}
          onClose={() => setConfirmDialogState(false)}
          cancelButtonLable='No, Stay'
          dialogType={DIALOG_TYPE.WARNING}
          justify='end'
        >
          <Typography variant='body2' color='text.secondary'>
            This action cannot be undone, changes that have you made will be
            lost.
          </Typography>
        </Dialog>
      </Box>
    </AssessmentContext.Provider>
  );
};
